import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';
import AccountModel from './account-model';
import RelativeAccountCollection from './relative-account-collection';
import AccountApiDataModel from './account-api-data-model';

function fetchCurrentAccount() {
  return (
    ajaxService
      .get('/api/account/show.json')
      .then(ApiUtils.validate, ApiUtils.validate)
      .then(ApiUtils.extract1)
      // AccountApiDataModel provides a dedicated deserialization for Account API response data
      // before the data is merged into the AccountModel entity.
      .then(AccountApiDataModel.deserialize)
  );
}

function updateAccount(account) {
  return ajaxService
    .post('/api/account/update.json', AccountModel.serialize(account))
    .then(ApiUtils.validate)
    .then((response) => {
      const successMessage = response.data.statusmsg;
      const account = AccountModel.deserialize(ApiUtils.extract1(response));
      return { successMessage, account };
    })
    .catch((error) => ({ error }));
}

/**
 * Fetches relative accounts(childrens or parent) of the current account
 */
function fetchRelativeAccounts() {
  return ajaxService
    .get('/api/account/accountsCanWorkInto.json', { excludeCurrentAccount: true })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(RelativeAccountCollection.deserialize);
}

export default {
  fetchCurrentAccount,
  updateAccount,
  fetchRelativeAccounts,
};
